import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function ExitReason() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();

  return (
    <fieldset>
      <legend>{t("Exit Reason")}</legend>
      <input
        name="exitReason"
        onChange={onChange}
        value={searchObject.exitReason || ""}
        className="form-control"
      />
    </fieldset>
  );
}
